import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { slotShapePath } from '../../../core/utils/stamp-grid.util';
import { inkFor } from '../../../core/utils/color.util';

/** Casilla de sello (Stamp Slot): vacía, llena (imagen del sello sobre su color) o recompensa. */
@Component({
  selector: 'app-stamp-slot',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <svg viewBox="-4 -4 64 64" xmlns="http://www.w3.org/2000/svg">
      @if (state() === 'reward') {
        <path [attr.d]="path()" [attr.fill]="color()" />
        <path [attr.d]="path()" fill="none" [attr.stroke]="ink()" stroke-width="1.6" stroke-dasharray="3 3"
              transform="translate(28 28) scale(1.12) translate(-28 -28)" opacity=".7" />
        <g [attr.stroke]="ink()" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" transform="translate(18 11) scale(.84)">
          <path d="M20 12V22H4V12M22 7H2V12H22V7ZM12 22V7M12 7H7.5C6.83696 7 6.20107 6.73661 5.73223 6.26777C5.26339 5.79893 5 5.16304 5 4.5C5 3.83696 5.26339 3.20107 5.73223 2.73223C6.20107 2.26339 6.83696 2 7.5 2C11 2 12 7 12 7ZM12 7H16.5C17.163 7 17.7989 6.73661 18.2678 6.26777C18.7366 5.79893 19 5.16304 19 4.5C19 3.83696 18.7366 3.20107 18.2678 2.73223C17.7989 2.26339 17.163 2 16.5 2C13 2 12 7 12 7Z" />
        </g>
        <text x="28" y="43" text-anchor="middle" [attr.fill]="ink()" font-family="DM Sans, sans-serif" font-weight="700" font-size="7" letter-spacing=".7">PREMIO</text>
      } @else {
        <path [attr.d]="path()" [attr.fill]="state() === 'filled' && imageBg() ? imageBg() : color()" />
        @if (state() === 'filled' && imageUrl()) {
          <image [attr.href]="imageUrl()" x="12" y="12" width="32" height="32" preserveAspectRatio="xMidYMid meet" />
        }
      }
    </svg>
  `,
  styles: [`:host{display:block;line-height:0} svg{width:100%;height:100%;overflow:visible}`],
})
export class StampSlotComponent {
  readonly shape = input<string>('circle');
  readonly color = input<string>('#F4EAD8');
  readonly state = input<'empty' | 'filled' | 'reward'>('empty');
  readonly imageUrl = input<string | null | undefined>(null);
  readonly imageBg = input<string | null | undefined>(null);
  readonly path = computed(() => slotShapePath(this.shape()));
  readonly ink = computed(() => inkFor(this.color()));
}
